<li class="notes" *ngIf="notesToDisplay.length > 0">
  <span class="inspection-item" [class.root]="root">הערות כלליות:</span>
  <ol>
    <li *ngFor="let item of notesToDisplay">
      <strong style="display: table-cell">{{ item.notes }}</strong>
      <ol style="margin-right: 15px">
        <li
          *ngFor="
            let subNote of item.subNotes
              | filterBy : ['addNotesToReport'] : true
          "
        >
          <strong style="display: table-cell">{{ subNote.notes }}</strong>
        </li>
      </ol>
    </li>
  </ol>
</li>
